/**
 * @link https://documenter.getpostman.com/view/4774204/RznEJdda
 */
export const Endpoints = {

    // auth
    login: 'oauth/token',
    login_micro_service: 'api/v1/auth/token',
    logout: 'user/logout',
    self: 'user/self',
    change_password: 'user/changePassword',
    module_list: 'module/list',
    organization_modules: 'module/getListByOrganization',
    organization_list: 'organization/search',
    organization_details: 'organization/details',
    organization_add: 'organization/add',
    organization_edit: 'organization/edit',
    organization_delete: 'organization',
    organization_list_new: 'api/organization/manage/list',
    organization_status_update: 'api/organization/update-status',
    bill_pending_organization_list: 'billPendingOrg/list',
    add_bill_pending_organization: 'billPendingOrg/add',
    delete_bill_pending_organization: 'billPendingOrg',
    set_restriction_message: 'billPendingOrg/setRestrictionMessage',
    get_restriction_message: 'billPendingOrg/getRestrictionMessage',
    app_update: 'organization/updateAndroidAppInfo',
    distributor_app_update: 'organization/updateDistributorAppInfo',
    app_update_info: 'organization/androidAppInfo',
    organization_settings: 'organizationSettings/list',
    self_detail: 'api/user/self/detail',
    self_authorities: 'api/user/self/authorities',
    org_authorities: 'api/user/self/org/authorities',
    org_sync: 'api/organization/sync-to-client-app',
    market_level: 'api/market-level/list',
    environment_config: 'assets/config.json',


    // dashboard
    dashboard_market_daily_kpi: 'kpi/marketDailyKpi',
    dashboard_market_daily_kpi_by_plan_visit: 'api/plan-visit-order-target-vol-kpi/kpi',
    dashboard_hit_count: 'actuator/hitCount',
    dashboard_role_wise_presence_count: 'attendance/roleWisePresenceCount',
    dashboard_market_presence_count: 'attendance/marketWisePresenceCount',
    dashboard_order_summary: 'secondaryOrder/orderSummary',
    dashboard_market_wise_order_summary: 'secondaryOrder/marketWiseOrderSummary',
    dashboard_user_count: 'user/countFieldOperatives',
    dashboard_planned_retailer_count: 'tourPlan/plannedRetailerCount',
    dashboard_ordered_retailer_count: 'secondaryOrder/orderedRetailerCount',
    dashboard_user_present_count: 'attendance/presenceCountOfFieldOperatives',
    dashboard_total_orders_of_day: 'secondaryOrder/orderTotalOfDay',
    dashboard_visited_retailer_count: 'engagement/visitedRetailerCount',
    dashboard_secondary_order_target_of_day: 'v4/marketTargetReport/marketSecondaryOrderTargetAmountOfDay',
    dashboard_secondary_delivery_target_of_day: 'v4/marketTargetReport/marketSecondaryDeliveryTargetAmountOfDay',
    dashboard_secondary_collection_target: 'v4/marketTargetReport/marketSecondaryCollectionTargetAmountOfDay',
    dashboard_total_invoices: 'customerInvoice/invoiceTotalOfDay',
    dashboard_total_customer_payment: 'customerPayment/totalOfDay',
    dashboard_secondary_order_target_of_month: 'v4/marketTargetReport/marketSecondaryOrderTargetAmountOfMonth',
    dashboard_secondary_order_achievement_of_month: 'v4/marketTargetReport/marketSecondaryOrderAchievedAmountOfMonth',
    dashboard_average_visit_time: 'engagement/averageRetailerVisitTime',
    dashboard_payment_summary: 'customerPayment/totalOfDay',
    dashboard_market_wise_payment_summary: 'customerPayment/marketWisePaymentSummary',
    dashboard_order_summary_by_product: 'secondaryOrder/orderSummaryByProduct',
    dashboard_sales_kpi: 'api/plan-visit-order-invoice-kpi/get-user-kpi/for-dashboard',

    dashboard_customer_order: 'dashBoard/customerOrder',
    dashboard_retailer_to_dealer_order: 'dashBoard/retailerToDealerOrder',
    dashboard_customer_dummy_order: 'dashBoard/customerDummyOrder',
    dashboard_brand_sales_dummy: 'dashBoard/brandDummySalesReport',
    dashboard_distributor_order_invoice_payment: 'dashBoard/distributorOrderInvoicePayment',
    dashboard_dealer_order_summary: 'dashBoard/dealerOrderSummary',
    dashboard_dealer_invoice_summary: 'dashBoard/dealerInvoiceSummary',
    dashboard_retailer_order_summary: 'dashBoard/retailerOrderSummary',
    dashboard_retailer_invoice_summary: 'dashBoard/retailerInvoiceSummary',
    dashboard_market_sales_target: 'dashBoard/marketSalesTarget',
    dashboard_monthly_retailer_order_vs_visit: 'dashBoard/dayWiseRetailerVisitSummary',
    dashboard_monthly_retailer_order_vs_invoice: 'dashBoard/dayWiseRetailerOrderInvoiceAmount',
    dashboard_sales_target_by_product_brand: 'dashBoard/salesTargetByProductBrand',
    dashboard_sales_target_by_product_group: 'dashBoard/salesTargetByProductGroup',
    dashboard_sales_target_by_product_line: 'dashBoard/salesTargetByProductLine',
    dashboard_sales_target_by_product_type: 'dashBoard/salesTargetByProductType',
    dashboard_customer_visit_summary: 'dashBoard/customerVisitSummary',
    dashboard_distributor_visit_summary: 'dashBoard/distributorVisitSummary',
    dashboard_attendance_count_summary: 'dashBoard/attendanceCount',
    dashboard_customer_visit_count: 'dashBoard/customerVisitCount',
    dashboard_customer_visit_count_dummy: 'dashBoard/customerVisitCountDummy',
    dashboard_monthly_sales_comparison_dummy: 'dashBoard/dummySalesComparisonWithPreviousMonth',
    dashboard_daily_sales_comparison_dummy: 'dashBoard/dailyDummySalesComparison',
    dashboard_avg_sales_comparison_dummy: 'dashBoard/dummyAvgDbSalesComparisonWithPreviousMonth',
    dashboard_new_customer_count: 'dashBoard/newCustomerCount',
    dashboard_new_customer_count_dummy: 'dashBoard/newCustomerCountDummy',
    dashboard_attendance_count: 'dashBoard/attendanceCount',
    dashboard_market_wise_order_vs_delivery: 'api/retailer-order-report/order-summary-card',
    dashboard_brand_wise_order_vs_delivery: 'api/retailer-order-report/brand-wise-order-summary-card',
    dashboard_market_wise_target_delivery_total: 'api/market-product-target-report/market-wise-target-delivery/for-dashboard/total',
    dashboard_market_wise_target_delivery_list: 'api/market-product-target-report/market-wise-target-delivery/for-dashboard',
    export_dashboard_market_wise_target_delivery_list: 'api/market-product-target-report/market-wise-target-delivery/for-dashboard/export',
    dashboard_brand_wise_target_delivery_total: 'api/market-product-target-report/brand-wise-target-delivery/for-dashboard/total',
    dashboard_brand_wise_target_delivery_list: 'api/market-product-target-report/brand-wise-target-delivery/for-dashboard',
    export_dashboard_brand_wise_target_delivery_list: 'api/market-product-target-report/brand-wise-target-delivery/for-dashboard/export',

    // attendance
    attendance_list: 'attendance/list',
    attendance_add: 'attendance/add',
    attendance_edit: 'attendance/edit',
    attendance_user_list: 'attendance/userList',
    export_attendance_user_list: 'attendance/exportUserList',
    daily_shift_wise_attendance_list: 'attendance/dayWiseAttendanceWithShift',
    daily_shift_wise_attendance_new: 'api/presence-report/day-and-shift-wise-attendance',
    export_daily_shift_wise_attendance_list: 'attendance/exportDayWiseAttendanceWithShift',
    export_daily_shift_wise_attendance_list_new: 'api/presence-report/day-and-shift-wise-attendance/export',
    attendance_registry: 'attendance/registrar',
    attendance_registry_new: 'api/presence-report/attendance-registry',
    export_attendance_registry_new: 'api/presence-report/attendance-registry/export',
    export_attendance_registry: 'attendance/exportRegistrar',
    daily_shift_list: 'dailyShift/list',
    daily_shift_details: 'dailyShift',
    daily_shift_add: 'dailyShift/add',
    daily_shift_edit: 'dailyShift/edit',
    attendance_submission_rule_list: 'attendanceSubmissionRule/list',
    attendance_submission_add: 'attendanceSubmissionRule/add',
    attendance_submission_update: 'attendanceSubmissionRule/update',
    attendance_submission_remove: 'attendanceSubmissionRule',
    attendance_location_rule: 'api/attendance-Location-rule/list',
    attendance_location_rule_remove: 'api/attendance-Location-rule/remove',
    attendance_location_rule_update: 'api/attendance-Location-rule/update',
    movement_list: 'api/movement/list',
    movement_approve: 'api/movement/approve',

    // campaign
    distributor_camp_list: 'distributorCampaign/list',
    distributor_camp_details: 'distributorCampaign',
    distributor_camp_add: 'distributorCampaign/add',
    distributor_camp_edit: 'distributorCampaign/edit',
    customer_camp_list: 'customerCampaign/list',
    customer_camp_details: 'customerCampaign',
    customer_camp_add: 'customerCampaign/add',
    customer_camp_edit: 'customerCampaign/edit',
    dealer_campaign_list: 'dealerCampaign/list',
    dealer_campaign_details: 'dealerCampaign',
    dealer_campaign_add: 'dealerCampaign/add',
    dealer_campaign_edit: 'dealerCampaign/edit',
    retailer_to_dealer_campaign_list: 'retailerToDealerCampaign/list',
    retailer_to_dealer_campaign_add: 'retailerToDealerCampaign/add',
    retailer_to_dealer_campaign_edit: 'retailerToDealerCampaign/edit',
    retailer_to_dealer_campaign_details: 'retailerToDealerCampaign',
    product_campaign_list: 'productCampaign/list',
    product_campaign_details: 'productCampaign',
    product_campaign_add: 'productCampaign/add',
    product_campaign_edit: 'productCampaign/edit',

    // central stock
    central_stock_transfer_details: 'centralStock/transfer',
    central_stock_add: 'centralStock/add',
    centralStockList: 'centralStock/list',
    centralStockTransaction: 'centralStock/transactionList',
    centralStock_transfer_list: 'centralStock/transfer/list',
    central_stock_transfer_approve: 'centralStock/transfer/approve',
    productStockSummary: 'centralStock/productStockSummary',
    distributor_product_stock_movement_report: 'api/distributor-stock/stock-movement-report',
    export_distributor_product_stock_movement_report: 'api/distributor-stock/stock-movement-report/export',
    distributor_wise_primary_vs_secondary_by_brand_report: 'api/sales-report/distributor-wise-primary-vs-secondary-by-brand',
    export_distributor_wise_primary_vs_secondary_by_brand_report: 'api/sales-report/distributor-wise-primary-vs-secondary-by-brand/export',

    // code generator rule
    code_generator_rule_list: 'codeGeneratorRule/list',
    code_generator_rule_add: 'codeGeneratorRule/add',
    code_generator_rule_edit: 'codeGeneratorRule/edit',
    code_generator_rule_detail: 'codeGeneratorRule',
    code_generator_rule_delete: 'codeGeneratorRule',

    // taDa
    daily_ta_da_list: 'dailyTaDa/list',
    export_daily_ta_da_list: 'dailyTaDa/export',
    daily_ta_da_details: 'dailyTaDa',
    daily_ta_da_details_by_user_role_market: 'dailyTaDa/details',
    daily_ta_da_manage: 'dailyTaDa/manage',
    daily_ta_da_claim_list: 'dailyTaDaClaim/list',
    daily_ta_da_claim_list_export: 'dailyTaDaClaim/export',
    export_distributor_center_stock: 'distributionCenterStock/stockList/export',
    daily_ta_da_claim_details: 'dailyTaDaClaim',
    daily_ta_da_claim_delete: 'dailyTaDaClaim',
    daily_ta_da_claim_details_by_user_market_date: 'dailyTaDaClaim/details',
    daily_ta_da_claim_add: 'dailyTaDaClaim/add',
    daily_ta_da_claim_edit: 'dailyTaDaClaim/edit',
    daily_ta_da_claim_reset: 'dailyTaDaClaim/resetApproval',
    tour_allowance_list: 'tourAllowance/claim/list',
    tour_allowance_claim_approve: 'tourAllowance/claim/approve',
    edit_allowance_rule: 'tourAllowance/edit',
    delete_allowance_rule: 'tourAllowance',
    create_allowance_rule: 'tourAllowance/add',
    allowance_rule_list: 'tourAllowance/list',
    tada_claim_bulk_approve: 'dailyTaDaClaim/bulkApprove',
    ta_claim_request: 'api/ta-da-claim/ta-claim-request/list',
    ta_claim_request_details: 'api/ta-da-claim/ta-claim-request/detail',
    ta_claim_request_approve: 'api/ta-da-claim/approve-request',
    ta_claim_request_reset: 'api/ta-da-claim/reset-ta-claim-request-status',
    apply_ta_for_subordinates: 'api/ta-da-claim/apply-ta-for-subordinate',
    trigger_da: 'api/ta-da-claim/trigger-da-processing',
    edit_applied_da: 'api/ta-da-claim/edit-applied-da',
    applied_ta_da_list: 'api/ta-da-claim/ta-da-list',
    applied_ta_da_export: 'api/ta-da-claim/ta-da-list/export',

    // dealer
    dealer_list_by_market: 'dealer/listByMarket',
    dealer_list: 'dealer/list',
    export_dealer_list: 'dealer/export',
    dealer_edit: 'dealer/edit',
    dealer_add: 'dealer/add',
    dealer_delete: 'dealer',
    dealer_details: 'dealer',
    dealer_type_list: 'dealerType/list',
    dealer_type_add: 'dealerType/add',
    dealer_type_edit: 'dealerType/edit',
    dealer_payment_details: 'dealerPayment',
    dealer_payment_add: 'dealerPayment/add',
    dealer_payment_edit: 'dealerPayment/edit',
    dealer_payment_list: 'dealerPayment/list',
    dealer_payment_approve: 'dealerPayment/approve',
    export_dealer_payment_list: 'dealerPayment/exportPaymentList',
    dealer_stock_list: 'dealerStock/list',
    dealer_stock_summary: 'dealerStock/stockSummary',
    dealerAccountTransaction: 'dealer/transactions',
    export_dealer_stock_list: 'dealerStock/exportStockList',


    // delivery challan
    distributor_delivery_challan_list: 'distributorDelivery/list',
    distributor_delivery_challan_export: 'distributorDelivery/export',
    distributor_delivery_challan_details: 'distributorDelivery',
    distributor_delivery_challan_by_product_details: 'distributorProductDelivery',
    distributor_delivery_challan_add: 'distributorDelivery/add',
    distributor_delivery_challan_advice: 'distributorDelivery/advice',
    distributor_delivery_challan_cancel: 'distributorDelivery/cancel',
    distributor_delivery_challan_cancel_by_product_serial: 'distributorProductDelivery/cancel',
    distributor_delivery_challan_approve: 'distributorDelivery/approve',
    distributor_delivery_challan_approve_by_serial: 'distributorProductDelivery/approve',
    dealer_delivery_challan_list: 'dealerDelivery/list',
    dealer_delivery_challan_details: 'dealerDelivery',
    dealer_delivery_challan_advice: 'dealerDelivery/advice',
    dealer_delivery_challan_add: 'dealerDelivery/add',
    dealer_delivery_challan_cancel: 'dealerDelivery/cancel',
    dealer_delivery_challan_approve: 'dealerDelivery/approve',
    dealer_stock_transaction_list: 'dealerStock/transactions',
    retailer_to_dealer_delivery_challan_list: 'retailerToDealerDelivery/list',
    retailer_to_dealer_delivery_challan_details: 'retailerToDealerDelivery',
    retailer_to_dealer_delivery_challan_advice: 'retailerToDealerDelivery/advice',
    retailer_to_dealer_delivery_challan_add: 'retailerToDealerDelivery/add',
    retailer_to_dealer_delivery_challan_cancel: 'retailerToDealerDelivery/cancel',
    retailer_to_dealer_delivery_challan_approve: 'retailerToDealerDelivery/approve',
    customer_delivery_challan_list: 'customerDelivery/list',
    customer_delivery_challan_details: 'customerDelivery',
    customer_delivery_challan_details_by_product: 'customerProductDelivery',
    customer_delivery_challan_add: 'customerDelivery/add',
    customer_delivery_challan_add_by_product: 'customerProductDelivery/add',
    customer_delivery_challan_advice: 'customerDelivery/advice',
    customer_delivery_challan_advice_by_product: 'customerProductDelivery/advice',
    customer_delivery_challan_cancel: 'customerDelivery/cancel',
    customer_delivery_challan_cancel_by_product: 'customerProductDelivery/cancel',
    customer_delivery_challan_approve: 'customerDelivery/approve',
    customer_delivery_challan_approve_by_product: 'customerProductDelivery/approve',
    customer_list_for_delivery_challan: 'customer/waitingForDelivery',

    // distribution center
    distributor_centre_list: 'distributionCenter/list',
    distributor_centre_details: 'distributionCenter',
    distributor_centre_add: 'distributionCenter/add',
    distributor_centre_edit: 'distributionCenter/edit',
    distributionCenterStockList: 'distributionCenterStock/stockList',
    distributionCenterStockTransaction: 'distributionCenterStock/stockTransactionList',

    // distributor
    distributor_type_list: 'distributorType/list',
    distributor_type_details: 'distributorType',
    distributor_type_add: 'distributorType/add',
    distributor_type_edit: 'distributorType/edit',

    distributor_list: 'distributor/list',
    export_distributor_list: 'distributor/export',
    distributor_list_by_market: 'distributor/listByMarket',
    distributor_list_for_delivery_challan: 'distributor/waitingForDelivery',
    distributor_details: 'distributor',
    distributor_user_details: 'distributorUser',
    distributor_add: 'distributor/add',
    distributor_edit: 'distributor/edit',


    distributor_delivery_challan_add_by_product: 'distributorProductDelivery/add',

    distributor_invoice_preview: 'distributorInvoice/preview',
    distributor_invoice_list: 'distributorInvoice/list',
    distributor_invoice_details: 'distributorInvoice',
    distributor_invoice_add: 'distributorInvoice/add',
    distributor_invoice_edit: 'distributorInvoice/edit',
    distributor_invoice_campaign_preview: 'distributorInvoice/preview',
    distributor_invoice_cancel: 'distributorInvoice/cancel',
    distributor_payment_collection: 'distributorInvoice/paymentCollectionReport',
    distributor_payment_collection_export: 'distributorInvoice/exportPaymentCollectionReport',
    distributor_payment_list: 'distributorPayment/list',
    export_distributor_payment_list: 'distributorPayment/export',
    distributor_payment_details: 'distributorPayment',
    distributor_payment_add: 'distributorPayment/add',
    distributor_payment_edit: 'distributorPayment/edit',
    distributor_payment_approve: 'distributorPayment/approve',
    distributor_payment_with_deposit_approve: 'distributorPayment/approveWithDepositAccount',
    distributor_payment_reset: 'distributorPayment/reset',
    distributor_payment_cancel: 'distributorPayment/cancel',
    distributor_bank_account_list: 'distributorBankAccount/list',
    distributor_bank_account_details: 'distributorBankAccount',
    distributor_bank_account_add: 'distributorBankAccount/add',
    distributor_bank_account_edit: 'distributorBankAccount/edit',
    distributor_bank_account_delete: 'distributorBankAccount',
    distributor_bank_account_approve: 'distributorBankAccount/approve',



    distributor_safety_stock: 'distributorSafetyStock/list',
    distributor_safety_stock_add: 'distributorSafetyStock/add',
    distributor_safety_stock_edit: 'distributorSafetyStock/edit',
    distributor_safety_stock_detail: 'distributorSafetyStock',

    distributor_stock_transfer_list: 'dbStockTransfer/list',
    distributor_stock_transfer_export: 'dbStockTransfer/exportList',
    market_list_of_distributor: 'market/marketsOfDistributor',
    customer_list_of_distributor: 'distributor/retailers',
    user_list_of_distributor: 'distributor/fieldForces',
    distributorAccountTransaction: 'distributor/transactions',
    distributorDailySummary: 'distributor/distributorSummary',
    export_distributor_daily_sales_summary: 'distributor/exportDistributorSummary',
    distributor_sales_summary: 'salesSummary/distributor',
    export_distributor_sales_summary: 'salesSummary/distributor/export',
    distributor_request_list: 'distributorRequest/list',
    distributor_request_details: 'distributorRequest',
    distributor_request_sound_alike: 'distributorRequest/soundAlike',
    distributor_request_edit: 'distributorRequest/edit',
    distributor_sales_target: 'v2/distributorTarget/primaryTargetAchievement',
    distributor_product_group_target: 'v2/distributorProductGroupTarget/primaryTargetAchievement',
    distributor_sales_target_v3: 'target/sales/distributor/view',
    distributor_product_sales_target_v3: 'target/sales/product/distributor/view',
    distributor_product_line_sales_target_v3: 'target/sales/productLine/distributor/view',

    // expense
    expense_type_list: 'expenseType/list',
    expense_sub_type_list: 'expenseSubType/list',
    expense_type_details: 'expenseType',
    expense_sub_type_details: 'expenseSubType',
    expense_type_add: 'expenseType/add',
    expense_sub_type_add: 'expenseSubType/add',
    expense_type_edit: 'expenseType/edit',
    expense_sub_type_edit: 'expenseSubType/edit',
    expense_purpose_list: 'expensePurpose/list',
    expense_purpose_details: 'expensePurpose',
    expense_purpose_add: 'expensePurpose/add',
    expense_purpose_edit: 'expensePurpose/edit',
    expense_claim_list: 'expenseClaim/list',
    export_expense_claim_list: 'expenseClaim/exportList',
    expense_claim_itemised_list: 'expenseClaim/itemisedList',
    expense_claim_details: 'expenseClaim',
    expense_claim_add: 'expenseClaim/add',
    expense_claim_edit: 'expenseClaim/edit',
    expense_claim_bulk_approve: 'expenseClaim/bulkApprove',
    expense_claim_reset_approval: 'expenseClaim/resetApproval',
    billing_organization_list: 'billingOrganization/list',
    billingOrganization_list: 'billingOrganization/listForUser',

    // geo hierarchy
    division_list: 'division/list',
    division_edit: 'division/edit',
    division_add: 'division/add',
    district_edit: 'district/edit',
    district_add: 'district/add',
    district_list: 'district/list',
    thana_list: 'thana/list',
    thana_edit: 'thana/edit',
    thana_add: 'thana/add',
    union_or_town_list: 'unionOrTown/list',
    union_or_town_edit: 'unionOrTown/edit',
    union_or_town_add: 'unionOrTown/add',

    // invoice
    customer_invoice_list: 'customerInvoice/list',
    customer_invoice_details: 'customerInvoice',
    customer_invoice_total_amount: 'customerInvoice/list/total-amount',
    export_customer_invoice_list: 'customerInvoice/list/export',
    multiple_invoice_from_order: 'customerInvoice/createInvoiceFromOrder',
    retailer_to_dealer_invoice_from_order: 'retailerToDealerInvoice/createInvoiceFromOrder',
    customer_invoice_add: 'customerInvoice/add',
    dealer_invoice_list: 'dealerInvoice/list',
    retailer_to_dealer_invoice_list: 'retailerToDealerInvoice/list',
    dealer_invoice_details: 'dealerInvoice',
    retailer_to_dealer_invoice_details: 'retailerToDealerInvoice',
    customer_invoice_list_v2: 'api/customer-invoice/list',
    fmcg_customer_invoice_details: 'api/customer-invoice',
    fmcg_customer_invoice_deliver: 'api/customer-invoice/deliver',
    fmcg_customer_invoice_reject: 'api/customer-invoice/reject',
    customer_invoice_cancel_v2: 'api/customer-invoice/cancel',

    customer_invoice_edit: 'customerInvoice/edit',
    dealer_invoice_edit: 'dealerInvoice/edit',
    dealer_invoice_add: 'dealerInvoice/add',
    retailer_to_dealer_invoice_edit: 'retailerToDealerInvoice/edit',
    retailer_to_dealer_invoice_add: 'retailerToDealerInvoice/add',
    customer_invoice_campaign_preview: 'customerInvoice/preview',
    customer_invoice_cancel: 'customerInvoice/cancel',
    dealer_invoice_cancel: 'dealerInvoice/cancel',
    retailer_to_dealer_invoice_cancel: 'retailerToDealerInvoice/cancel',
    customer_invoice_preview: 'customerInvoice/preview',
    dealer_invoice_preview: 'dealerInvoice/preview',
    retailer_to_dealer_invoice_preview: 'retailerToDealerInvoice/preview',
    fmcg_customer_invoice_preview: 'api/customer-invoice/preview',
    save_fmcg_customer_invoice: 'api/customer-invoice/create',
    customer_invoice_preview_after_delivery: 'api/customer-invoice/previewForEditAfterDelivery',
    edit_customer_invoice_after_delivery: 'api/customer-invoice/editAfterDelivery',

    // leave management
    holiday_list: 'holiday/list',
    holiday_details: 'holiday',
    holiday_add: 'holiday/add',
    holiday_edit: 'holiday/edit',
    weekend_request_list: 'weekend/requestList',
    edit_weekend_request: 'weekend/editRequest',
    approve_weekend_request: 'weekend/approveRequest',
    set_weekend_request: 'weekend/setWeekendForUser',
    leave_type_list: 'leaveType/list',
    leave_type_details: 'leaveType',
    leave_type_add: 'leaveType/add',
    leave_type_edit: 'leaveType/edit',
    leave_allocation_list: 'leaveAllocation/list',
    leave_allocation_details: 'leaveAllocation',
    leave_allocation_add: 'leaveAllocation/add',
    leave_allocation_edit: 'leaveAllocation/edit',
    leave_account_list: 'leaveAccount/list',
    leave_account_export: 'leaveAccount/exportList',
    leave_account_manage: 'leaveAccount/manage',
    user_leave_list: 'userLeave/list',
    user_leave_details: 'userLeave',
    user_leave_add: 'userLeave/add',
    user_leave_edit: 'userLeave/edit',
    team_leave_add: 'userLeave/addForOthers',
    update_user_attendance_reference: 'userAttendanceReference/update',

    // level
    level_list: 'level/list',
    level_add: 'level/add',
    level_edit: 'level/edit',
    level_details: 'level',

    // location
    timeline_by_date_range: 'location/userLocation/timeline/multipleDates',
    monitoring_user_last_locations: 'api/timeLine/last-locations',
    monitor_team_tracking: 'api/timeLine/user-timeline',
    export_monitor_user_timeline: 'api/timeLine/user-timeline/export',
    monitor_user_timeline_date_range: 'api/timeLine/user-timeline/date-range',
    export_monitor_user_timeline_date_range: 'api/timeLine/user-timeline/date-range/export',
    export_all_user_timeline_by_date_range: 'api/timeLine/all-user-timeline-by-date-range/export',
    generate_export_status: 'api/common/export-status',

    // location old
    distributor_location_list: 'location/distributorLocationList',
    distributor_location_delete: 'distributor/location',
    user_last_location_list: 'location/getLastLocationList',
    user_location_list: 'location/userLocationList',
    user_location_list_v2: 'location/userLocationList/v2',
    user_timeline: 'location/userLocation/timeline',
    dealer_location_list: 'location/dealerLocationList',
    user_location_delete: 'user/attendanceLocation',
    customer_location_delete: 'customer/location',
    customer_location_list: 'location/customerLocationList',

    // market
    market_level_list: 'marketLevel/getMarketLevelHierarchy',
    market_level_details: 'marketLevel',
    market_level_add: 'marketLevel/add',
    market_level_edit: 'marketLevel/edit',
    market_level_delete: 'marketLevel',
    market_list: 'market/list',
    market_list_micro_service: 'api/market/filter/list',
    export_market_list: 'market/export',
    market_details: 'market',
    market_add: 'market/add',
    market_edit: 'market/edit',
    market_delete: 'market',
    route_info: 'api/market/route-info-report',
    route_info_export: 'api/market/route-info-report/export',


    // noc
    customer_monthly_noc_list: 'monthlyNoc/list',
    save_customer_monthly_noc: 'monthlyNoc/add',
    get_customer_monthly_noc: 'monthlyNoc/retailer',

    // notice board
    notice_board_list: 'noticeBoard/listOfSubordinates',
    notice_details: 'noticeBoard',
    notice_edit: 'noticeBoard/edit',
    notice_add: 'noticeBoard/add',
    notice_board_for_others_list: 'api/noticeBoard/list',
    notice_board_for_others_details: 'api/noticeBoard/detail',
    notice_board_for_others_add: 'api/noticeBoard/add',
    notice_board_for_others_edit: 'api/noticeBoard/edit',
    notice_board_for_others_active_status: 'api/noticeBoard/change-activation',

    // income
    income_list: 'api/income/list',
    income_add: 'api/income/new-income',
    income_edit: 'api/income/edit-income',
    income_total: 'api/income/list/total',
    income_export: 'api/income/list/export',
    income_cancel: 'api/income/cancel',

    // fridge
    fridge_list: 'api/fridge/list',
    fridge_add: 'api/fridge/add',
    fridge_edit: 'api/fridge/edit',
    fridge_delete: 'api/fridge/delete',
    fridge_details: 'api/fridge',
    fridge_by_retailer: 'api/fridge/listByRetailer',
    fridge_withdraw: 'api/fridge/withdraw',
    fridge_inject: 'api/fridge/inject',
    fridge_availability_and_info_by_serial: 'api/fridge/availabilityAndInfoBySerial',
    fridge_history: 'api/fridge-history',
    stock_survey_list: 'api/stock-survey/list',
    stock_survey_details: 'api/stock-survey',
    stock_survey_export: 'api/stock-survey/list/export',
    stock_survey_export_with_product: 'api/stock-survey/listByProduct/export',

    // asset
    asset_list: 'api/asset/list',
    asset_add: 'api/asset/add',
    asset_edit: 'api/asset/edit',
    asset_delete: 'api/asset/delete',
    asset_details: 'api/asset',
    asset_by_retailer: 'api/asset/listByRetailer',
    asset_withdraw: 'api/asset/withdraw',
    asset_inject: 'api/asset/inject',
    asset_availability_and_info_by_serial: 'api/asset/availabilityAndInfoBySerial',
    asset_list_retailer: 'api/asset/list/retailer',
    asset_type_list: 'api/asset-type/list',
    asset_type_edit: 'api/asset-type/edit',
    asset_type_add: 'api/asset-type/add',
    asset_retailer_upload: 'api/asset/retailer-upload',
    asset_condition_list: 'api/asset-condition/list',
    asset_condition_edit: 'api/asset-condition/edit',
    asset_condition_add: 'api/asset-condition/add',
    export_asset_list: 'api/asset/list/export',

    // email
    email_notification_history: 'api/email-notification-history/email',

    // order
    primary_order_list: 'primaryOrder/list',
    quantity_for_primary_order: 'primaryOrder/list/quantity',
    quantity_for_secondary_order: 'secondaryOrder/list/quantity',
    primary_order_details: 'primaryOrder',
    primary_order_add: 'primaryOrder/add',
    primary_order_edit: 'primaryOrder/edit',
    primary_order_export: 'primaryOrder/exportList',
    primary_order_campaign_preview: 'primaryOrder/preview',
    primary_order_preview: 'primaryOrder/preview',
    secondary_order_preview: 'secondaryOrder/preview',
    dealer_order_preview: 'dealerOrder/preview',
    retailer_to_dealer_order_preview: 'retailerToDealerOrder/preview',

    primary_order_approve: 'primaryOrder/approve',
    primary_order_close: 'primaryOrder/close',
    product_status_distributor: 'product/setAvailableForPrimaryOrder',

    primary_order_tracking: 'orderReport/trackOrderAndInvoice',
    export_primary_order_tracking: 'orderReport/exportPrimaryOrderTracking',
    dealer_order_details: 'dealerOrder',
    retailer_to_dealer_order_details: 'retailerToDealerOrder',
    secondary_order_list: 'secondaryOrder/list',
    secondary_order_list_export: 'secondaryOrder/exportOrderList',
    secondary_order_details: 'secondaryOrder',
    secondary_order_add: 'secondaryOrder/add',
    secondary_order_edit: 'secondaryOrder/edit',
    secondary_order_campaign_preview: 'secondaryOrder/preview',
    secondary_order_approve: 'secondaryOrder/approve',
    secondary_order_close: 'secondaryOrder/close',
    secondary_order_tracking: 'secondaryOrder/trackOrderById',
    export_secondary_order_tracking: 'secondaryOrder/exportTrackOrderById',
    dealer_order_list: 'dealerOrder/list',
    dealer_order_add: 'dealerOrder/add',
    dealer_order_edit: 'dealerOrder/edit',
    dealer_order_approve: 'dealerOrder/approve',
    dealer_order_close: 'dealerOrder/close',
    dealer_order_tracking: 'orderReport/dealerOrderTracking',
    dealer_order_tracking_export: 'orderReport/exportDealerOrderTracking',
    retailer_to_dealer_order_list: 'retailerToDealerOrder/list',
    retailer_to_dealer_order_list_export: 'retailerToDealerOrder/exportOrderList',
    retailer_to_dealer_order_approve: 'retailerToDealerOrder/approve',
    retailer_to_order_close: 'retailerToDealerOrder/close',
    retailer_to_dealer_order_add: 'retailerToDealerOrder/add',
    retailer_to_dealer_order_edit: 'retailerToDealerOrder/edit',

    akij_plastic_secondary_order_list: 'api/akijplastics/secondaryorder/list',
    akij_plastic_secondary_order_details: 'api/akijplastics/secondaryorder',
    akij_plastic_secondary_order_add: 'api/akijplastics/secondaryorder/add',
    akij_plastic_secondary_order_edit: 'api/akijplastics/secondaryorder/edit',
    akij_plastic_secondary_order_approve: 'api/akijplastics/secondaryorder/approve',
    akij_plastic_secondary_order_reset: 'api/akijplastics/secondaryorder/resetApprovalStatus',
    akij_plastics_secondary_order_preview: 'api/akijplastics/secondaryorder/preview',
    export_akij_plastic_secondary_order_list: 'api/akijplastics/secondaryorder/list/export',

    creditOption_list: 'creditOption/list',
    creditOption_details: 'creditOption',
    creditOption_add: 'creditOption/add',
    creditOption_edit: 'creditOption/edit',

    market_list_by_distributor: 'market/operatingMarketListOnDistributor',
    market_list_by_customer: 'market/operatingMarketListOnCustomer',
    market_list_by_distributor_and_customer: 'market/operatingMarketListOnCustomerAndDistributor',
    market_list_by_distributor_and_dealer: 'market/operatingMarketListOnDealerAndDistributor',
    market_list_by_customer_and_dealer: 'market/operatingMarketListOnCustomerAndDealer',

    // organization


    // poi
    poi_type_list: 'poi/type/list',
    poi_list: 'poi/list',
    edit_poi: 'poi/edit',
    create_poi: 'poi/add',
    poi_details: 'poi',
    user_poi_update: 'user/update/jobSite',
    update_poi_location: 'poi/update/location',

    // payment
    payment_purpose_list: 'paymentPurpose/list',
    payment_purpose_details: 'paymentPurpose',
    payment_purpose_add: 'paymentPurpose/add',
    payment_purpose_edit: 'paymentPurpose/edit',

    payment_category_list: 'paymentCategory/list',
    payment_category_details: 'paymentCategory',
    payment_category_add: 'paymentCategory/add',
    payment_category_edit: 'paymentCategory/edit',
    payment_method_list: 'paymentMethod/list',
    payment_method_details: 'paymentMethod',
    payment_method_add: 'paymentMethod/add',
    payment_method_edit: 'paymentMethod/edit',

    bank_upload: 'bank/upload',
    change_active_status: 'bank/setActive',
    bank_update: 'bank/update',
    bank_add: 'bank/add',
    bank_list: 'bank/list',
    org_bank_account_list: 'organizationBankAccount/list',
    org_bank_account_details: 'organizationBankAccount',
    org_bank_account_add: 'organizationBankAccount/add',
    org_bank_account_edit: 'organizationBankAccount/edit',
    org_bank_account_delete: 'organizationBankAccount',
    org_bank_account_approve: 'organizationBankAccount/approve',



    // product
    product_list: 'product/list',
    export_product_list: 'product/export',
    product_details: 'product',
    product_add: 'product/add',
    product_edit: 'product/edit',

    product_status_retailer: 'product/setAvailableForRetailerOrder',
    product_status: 'product/setActive',
    product_status_dealer: 'product/setAvailableForDealerOrder',
    product_line_list: 'productLine/list',
    product_line_details: 'productLine',
    product_line_add: 'productLine/add',
    product_line_edit: 'productLine/edit',
    product_brand_list: 'productBrand/list',
    product_brand_details: 'productBrand',
    product_brand_add: 'productBrand/add',
    product_brand_edit: 'productBrand/edit',
    product_group_list: 'productGroup/list',
    product_group_details: 'productGroup',
    product_group_add: 'productGroup/add',
    product_group_edit: 'productGroup/edit',
    product_type_list: 'productType/list',
    product_type_details: 'productType',
    product_type_add: 'productType/add',
    product_type_edit: 'productType/edit',
    tag_list: 'tag/list',
    tag_details: 'tag',
    tag_add: 'tag/add',
    tag_edit: 'tag/edit',

    // project
    project_list: 'project/list',
    project_approve: 'project/approve',
    project_edit: 'project/edit',
    project_add: 'project/add',
    project_type_list: 'projectType/list',
    project_demand_document_type_list: 'projectDemandDocumentType/list',
    project_status_list: 'projectStatus/list',
    project_consultant_list: 'projectConsultant/list',
    project_properties_list: 'projectProperties/list',
    project_properties_value_list: 'projectPropertiesValue/list',
    project_demand_list: 'projectDemand/list',
    project_owner_type_list: 'projectOwnerType/list',
    project_type_edit: 'projectType/edit',
    project_status_edit: 'projectStatus/edit',
    project_demand_add: 'projectDemand/add',
    project_demand_edit: 'projectDemand/edit',
    project_consultant_edit: 'projectConsultant/edit',
    project_properties_edit: 'projectProperties/edit',
    project_properties_add: 'projectProperties/add',
    project_properties_value_edit: 'projectPropertiesValue/edit',
    project_properties_value_add: 'projectPropertiesValue/add',
    project_owner_type_edit: 'projectOwnerType/edit',
    project_demand_document_type_edit: 'projectDemandDocumentType/edit',
    project_type_add: 'projectType/add',
    project_status_add: 'projectStatus/add',
    project_owner_type_add: 'projectOwnerType/add',
    project_demand_document_type_add: 'projectDemandDocumentType/add',
    project_consultant_add: 'projectConsultant/add',
    project_details: 'project',
    project_type_details: 'projectType',
    project_status_details: 'projectStatus',
    project_consultant_details: 'projectConsultant',
    project_properties_details: 'projectProperties',
    project_properties_value_details: 'projectPropertiesValue',
    project_demand_details: 'projectDemand/project',
    project_owner_type_details: 'projectOwnerType',
    project_demand_document_type_details: 'projectDemandDocumentType',


    // retailer
    customer_approve: 'customer/approve',
    customerAccountTransaction: 'customer/transactions',
    customer_payment_list: 'customerPayment/list',
    customer_type_list: 'customerType/list',
    customer_type_details: 'customerType',
    customer_type_add: 'customerType/add',
    customer_type_edit: 'customerType/edit',
    customer_list: 'customer/list',
    customer_list_new: 'api/retailer/list',
    customer_list_new_export: 'api/retailer/list/export',
    export_customer_list: 'customer/export',
    customer_details: 'customer',
    customer_add: 'customer/add',
    customer_edit: 'customer/edit',
    export_customer_payment_list: 'customerPayment/exportPaymentList',
    customer_payment_details: 'customerPayment',
    customer_payment_add: 'customerPayment/add',
    customer_payment_edit: 'customerPayment/edit',
    customer_payment_approve: 'customerPayment/approve',
    retailer_sales_summary: 'salesSummary/retailer',
    retailer_stock_list: 'productSerialInfo/retailerStock',
    retailer_serial_wise_stock_count_list: 'productSerialInfo/retailerSerialWiseStockCount',
    export_retailer_sales_summary: 'salesSummary/retailer/export',
    customer_stock_list: 'retailerStock/list',
    change_customer_status: 'customer/activate',
    customer_zero_invoice_list: 'api/retailer/list/zero-invoiced',
    export_customer_zero_invoice_list: 'api/retailer/list/zero-invoiced/export',

    // return
    customer_return_reason_list: 'customerReturnReason/list',
    customer_return_reason_details: 'customerReturnReason',
    customer_return_reason_add: 'customerReturnReason/add',
    customer_return_reason_edit: 'customerReturnReason/edit',
    customer_return_list: 'customerReturn/list',
    export_customer_return_list: 'customerReturn/export',
    customer_return_list_by_product_serial: 'customerReturnedProduct/list',
    customer_return_details: 'customerReturn',
    customer_return_add: 'customerReturn/add',
    customer_return_edit: 'customerReturn/edit',
    customer_return_approve: 'customerReturn/approve',
    customer_return_approve_by_serial: 'customerReturnedProduct/approve',
    customer_return_refund: 'customerReturn/refund',
    distributor_return_reason_list: 'distributorReturnReason/list',
    distributor_return_reason_details: 'distributorReturnReason',
    distributor_return_reason_add: 'distributorReturnReason/add',
    distributor_return_reason_edit: 'distributorReturnReason/edit',
    add_distributor_return_by_serial: 'distributorReturnedProduct/add',
    product_serial_for_primary_return: 'distributorReturnedProduct/findBySerialForDistributorReturn',
    distributor_return_list: 'distributorReturn/list',
    distributor_return_list_by_product_serial: 'distributorReturnedProduct/list',
    distributor_return_details: 'distributorReturn',
    distributor_return_add: 'distributorReturn/add',
    distributor_return_edit: 'distributorReturn/edit',
    distributor_return_approve: 'distributorReturn/approve',
    distributor_return_approve_by_serial: 'distributorReturnedProduct/approve',
    distributor_return_refund: 'distributorReturn/refund',
    distributor_return_stock_list_by_product_serial: 'productSerialInfo/distributorReturnStock',
    export_distributor_stock_list_by_product_serial: 'productSerialInfo/distributorMainStock/export',
    general_return_list: 'api/retailer-return/list',
    general_return_add: 'api/retailer-return/create',
    general_return_edit: 'api/retailer-return/edit',
    general_return_details: 'api/retailer-return/details',
    general_return_approve: 'api/retailer-return/approve',
    general_return_reset: 'api/retailer-return/reset',
    export_general_return_list: 'api/retailer-return/list/export',


    // sample requisition
    sample_requisition_list: 'sampleRequisition/list',
    sample_requisition_export: 'sampleRequisition/list/export',
    approve_sample_requisition: 'sampleRequisition/approve',
    distributor_sample_requisition_details: 'sampleRequisition',


    // scheme
    scheme_details: 'scheme',
    scheme_edit: 'scheme/edit',
    scheme_add: 'scheme/add',
    scheme_list: 'scheme/list',


    // segment
    segment_list: 'segment/list',
    segment_add: 'segment/add',
    segment_edit: 'segment/edit',
    segment_details: 'segment',
    sub_segment_list: 'subSegment/list',
    sub_segment_add: 'subSegment/add',
    sub_segment_edit: 'subSegment/edit',
    sub_segment_details: 'subSegment',


    // target achievement
    kpi_target_achievement: 'akash/Kpi/targetAchievementList',
    edit_kpi_target_achievement: 'akash/Kpi/editUserTarget',
    edit_retailer_kpi_target_achievement: 'akash/Kpi/editRetailerTarget',
    dynamic_kpi_name_list: 'akash/dynamicKpi/nameList',
    dynamic_kpi_list: 'akash/dynamicKpi/list',
    retailer_kpi_target_achievement: 'akash/Kpi/retailerTargetAchievementList',

    // target achievement
    market_sales_target_list: 'salesTarget/list',
    market_sales_target_export: 'salesTarget/export',

    primary_market_sales_target_list: 'v2/marketTarget/primaryTargetAchievement',
    product_group_primary_market_sales_target: 'v2/marketProductGroupTarget/primaryTargetAchievement',
    product_primary_market_sales_target: 'v2/marketProductTarget/primaryTargetAchievement',
    secondary_market_sales_target_list: 'v2/marketTarget/secondaryTargetAchievement',
    product_secondary_market_sales_target: 'v2/marketProductTarget/secondaryTargetAchievement',
    product_group_secondary_market_sales_target: 'v2/marketProductGroupTarget/secondaryTargetAchievement',
    dealer_market_sales_target_list: 'v2/marketTarget/dealerTargetAchievement',

    user_secondary_target_achievement: 'v2/userTarget/secondaryTargetAchievement',
    user_secondary_product_group_target: 'v2/userProductGroupTarget/secondaryTargetAchievement',
    product_group_dealer_market_sales_target: 'v2/marketProductGroupTarget/dealerTargetAchievement',
    product_dealer_market_sales_target: 'v2/marketProductTarget/dealerTargetAchievement',
    user_sales_target_list: 'userTarget/list',
    product_sales_target_list: 'productSalesTarget/list',
    product_sales_target_export: 'productSalesTarget/export',
    user_product_sales_target_list: 'userProductTarget/list',
    misc_sales_target_list: 'miscSalesTarget/list',
    user_misc_sales_target_list: 'userMiscTarget/list',
    user_self_target: 'dailyMarketTarget/marketSalesCollectionPerformance',

    market_sales_target_v3: 'target/sales/market/view',
    market_product_sales_target_v3: 'target/sales/product/market/view',
    market_product_line_sales_target_v3: 'target/sales/productLine/market/view',
    market_sales_target_aggregate_v3: 'target/sales/market/view/aggMarketProductLine',
    view_market_target_achievement_list: 'v4/marketTargetReport/targetVsAchievement',
    export_market_target_achievement_list: 'v4/marketTargetReport/targetVsAchievement/export',
    view_market_target_list: 'v4/marketTarget/list',
    add_market_target: 'v4/marketTarget/add',
    update_market_target: 'v4/marketTarget/update',
    upload_market_target: 'v4/marketTarget/upload',
    market_target_report_list: 'v4/marketTargetReport/list',
    market_target_report_details: 'v4/marketTargetReport',
    add_market_target_report: 'v4/marketTargetReport/add',
    update_market_target_report: 'v4/marketTargetReport/update',
    person_wise_target_achievement_report: 'targetAchievement/personSummary',
    export_person_wise_target_achievement_report: 'targetAchievement/exportPersonSummary',
    create_market_product_target_report: 'api/market-product-target-report/create',
    update_market_product_target_report: 'api/market-product-target-report/update',
    market_product_target_report: 'api/market-product-target-report/list',
    market_product_target_achievement: 'api/market-product-target-report/target-achievement',
    export_market_product_target_achievement: 'api/market-product-target-report/target-achievement/export',
    upload_market_product_target: 'api/market-product-target-report/upload-target',
    market_brand_wise_product_target_achievement: 'api/market-product-target-report/brand-wise-target-achievement-report',
    export_market_brand_wise_product_target_achievement: 'api/market-product-target-report/brand-wise-target-achievement-report/export',
    market_product_target_report_update_active_status: 'api/market-product-target-report/update-active-status',


    // tertiary sales
    tertiary_sales_list: 'akash/tertiarySales/list',
    linnex_tertiary_sales_list: 'linnexTertiarySales/list',


    // tour plan
    tour_type_list: 'tourType/list',
    tour_type_details: 'tourType',
    tour_type_add: 'tourType/add',
    tour_type_edit: 'tourType/edit',
    tour_plan_user_list: 'tourPlan/userList',
    tour_plan_details: 'tourPlan',
    tour_plan_details_by_user_year_month: 'tourPlan/details',
    tour_plan_history: 'tourPlan/editHistory',
    tour_plan_history_export: 'tourPlan/editHistory/export',
    tour_plan_add: 'tourPlan/add',
    tour_plan_edit: 'tourPlan/edit',
    tour_plan_approve: 'tourPlan/approve',
    tour_plan_target_list: 'tourPlanTarget/list',
    tour_plan_target_add: 'tourPlanTarget/add',
    tour_plan_target_edit: 'tourPlanTarget/edit',
    item_wise_tour_plan_approve: 'tourPlan/approveItem',

    // pjp plan
    pjp_plan_details_by_user_year_month: 'api/pjp',
    pjp_list: 'api/pjp/list',
    pjp_unplanned_user_list: 'api/pjp/unplannedUserList',
    pjp_add_single_tour_plan: 'api/pjp/add-single-tour-plan',
    pjp_add_team_tour_plan: 'api/pjp/add-single-team-tour-plan',
    pjp_delete_single_tour_plan: 'api/pjp/delete-single-tour-plan',

    // route plan
    route_plan_list: 'api/route-plan/list',
    route_plan_unplanned_user_list: 'api/route-plan/unplannedUserList',
    route_plan_details_by_user_year_month: 'api/route-plan',
    route_delete_single_tour_plan: 'api/route-plan/delete-single-route-plan',
    update_single_route_plan: 'api/route-plan/update-route-plan-for-one-date',
    update_team_route_plan: 'api/route-plan/update-team-route-plan-for-one-date',

    // training
    training_list: 'training/listOfSubordinates',
    training_details: 'training',
    training_edit: 'training/edit',
    training_add: 'training/add',


    // transport
    transport_mode_edit: 'transportMode/edit',
    transport_mode_add: 'transportMode/add',
    transport_mode_list: 'transportMode/list',


    // user
    user_approve: 'user/approve',
    change_user_status: 'user/active',
    food_bill: 'dailyTaDaClaim/listOfUser',
    device_list: 'userDevice/list',
    device_remove: 'userDevice/remove',
    device_remove_for_micro_service: 'api/user-device',
    device_list_micro_service: 'api/user-device/userId/device-list',
    notification_list: 'systemNotification/list',
    sms_report: 'notification/smsReport',
    sms_report_with_cost: 'notification/smsReportWithCost',
    active_user_list_of_a_period: 'userActiveHistory/activeUserList',
    export_active_user_list: 'userActiveHistory/activeUserList/export',
    export_user_list: 'user/export',
    user_details: 'user',
    user_add: 'user/add',
    user_edit: 'user/edit',
    user_list_by_accessible_market: 'user/listByAccessibleMarket',
    user_role_list: 'userRole/list',
    user_role_details: 'userRole',
    user_role_add: 'api/user-role/create',
    user_role_edit: 'api/user-role/edit',
    user_role_detailed_list: 'api/user-role/get-detailed-list',
    user_role_details_v2: 'api/user-role/details',
    user_role_permission_list: 'api/authority/get-authorities-of-roles',
    update_role_authorities: 'api/authority/update-role-authorities',
    distributor_user_list: 'distributorUser/list',
    distributor_user_list_export: 'distributorUser/list/export',

    user_role_modules: 'module/getListForUserRole',
    user_list: 'user/list',
    dsr_user: 'dsrUser/list',
    export_dsr_list: 'dsrUser/list/export',
    user_stock: 'userStock/list',
    user_attendance_reference: 'userAttendanceReference/of',

    distributor_list_for_filter: 'distributor/listForFilterForUser',
    retailer_list_for_filter: 'customer/listForFilterForUser',
    project_list_for_filter: 'project/listForFilterForUser',

    market_list_of_user: 'market/marketsOfUser',
    retailer_list_of_user: 'customer/listOfUser',

    subordinate_user_role_list: 'api/user-role/list/subordinates',
    team_user_filter_list: 'api/team/user-filter/list',

    movement_user_role_list: 'api/movement/list/role-filter',

    // visit
    user_role_wise_visit_target: 'dailyRoleVisitTarget/list',
    edit_user_role_wise_visit_target: 'dailyRoleVisitTarget/edit',
    delete_user_role_wise_visit_target: 'dailyRoleVisitTarget',
    add_user_role_wise_visit_target: 'dailyRoleVisitTarget/add',
    visit_type_list: 'visitType/list',
    visit_summary_approval_list: 'visitSummaryApprovalRule/list',
    visit_summary_approval_delete: 'visitSummaryApprovalRule',
    visit_summary_approval_details: 'visitSummaryApprovalRule',
    visit_summary_approval_add: 'visitSummaryApprovalRule/add',
    visit_summary_approval_edit: 'visitSummaryApprovalRule/edit',
    visit_type_details: 'visitType',
    visit_type_add: 'visitType/add',
    visit_type_edit: 'visitType/edit',
    visit_status_list: 'visitStatus/list',
    visit_status_details: 'visitStatus',
    visit_status_add: 'visitStatus/add',
    visit_status_edit: 'visitStatus/edit',
    visit_list: 'visit/list',
    visit_details: 'visit',
    visit_add: 'visit/add',
    visit_edit: 'visit/edit',
    visit_approve: 'visit/approve',
    visit_type_field_name_list: 'visitType/fieldName/list',
    visit_list_export: 'visit/export',



    // attendance report
    attendance_user_list_shifting: 'attendance/userListWithShift',
    presence_report: 'attendance/presenceReport',
    attendance_ta_da_summary: 'attendance/attendanceAndTaDaSummary',
    status_registrar: 'attendance/statusRegistrar',
    export_status_registrar: 'attendance/statusRegistrar/export',

    attendance_ta_da_summary_export: 'attendance/exportAttendanceAndTaDaSummary',
    export_attendance_user_list_shifting: 'attendance/exportUserListWithShift',


    // dealer
    dealer_stock_report: 'dealerStock/stockSummaryByProductAndGroup',
    export_dealer_stock_report: 'dealerStock/exportStockSummaryByProductAndGroup',

    // distributor stock report
    distributor_return_stock_list: 'api/distributor-return-stock/list',
    distributor_return_stock_list_export: 'api/distributor-return-stock/list/export',
    distributor_return_stock_transaction_list: 'api/distributor-return-stock/transaction-list',
    distributor_return_stock_transaction_list_export: 'api/distributor-return-stock/transaction-list/export',
    distributor_stock_report: 'distributorStock/stockSummaryByProductAndGroup',
    distributor_stock_summary: 'distributorStock/stockSummary',
    distributor_stock_list: 'distributorStock/stockList',
    distributor_stock_adjust: 'distributorStock/adjust',
    distributor_stock_transaction_list: 'distributorStock/transactionList',
    export_distributor_stock_transaction_list: 'distributorStock/exportTransactionList',
    distributor_stock_list_by_product_serial: 'productSerialInfo/distributorMainStock',
    distributor_stock_list_idle: 'distributorStock/stockListWithIdleTime',
    export_distributor_stock_summary: 'distributorStock/exportStockSummary',
    export_distributor_stock_report: 'distributorStock/exportStockSummaryByProductAndGroup',
    export_distributor_stock_list: 'distributorStock/exportStockList',
    order_vs_delivery: 'distributor/orderVsDelivery',



    // expense claim report
    user_wise_expense_summary_report: 'expenseClaim/userWiseExpenseSummaryReport',
    user_wise_expense_summary_export: 'expenseClaim/exportUserWiseExpenseSummaryReport',
    expense_claim_per_user_report: 'expenseClaim/perUserReport',
    expense_claim_summary_report: 'expenseClaim/expenseSummaryReport',
    expense_claim_summary_export: 'expenseClaim/exportExpenseSummaryReport',
    customer_ordered_product_amount: 'orderReport/customerOrderedProductQuantityAndAmount',
    primary_order_tracking_report: 'orderReport/primaryOrderTracking',
    primary_order_details_report: 'primaryOrder/orderDetailsReport',
    export_primary_order_details_report: 'primaryOrder/exportOrderDetailsReport',
    export_customer_ordered_product_amount: 'orderReport/exportCustomerOrderedProductQuantityAndAmount',
    export_expense_claim_per_user_report: 'expenseClaim/exportPerUserReport',

    expenseClaim_approval_delete: 'expenseClaimApprovalRule',
    expenseClaim_approval_list: 'expenseClaimApprovalRule/list',
    expenseClaim_approval_add: 'expenseClaimApprovalRule/add',
    expenseClaim_approval_edit: 'expenseClaimApprovalRule/edit',
    expenseClaim_approval_details: 'expenseClaimApprovalRule',


    // kpi report
    person_wise_monthly_kpi_report: 'kpi/personWiseMonthlyKpi',


    // leave report
    user_leave_account: 'leaveReport/userAccountList',


    // notice report
    notice_seen_report: 'noticeBoard/seenReport',


    // order report
    order_count_amount_by_user: 'orderReport/orderCountAndAmountByUser',
    export_order_count_amount_by_user: 'orderReport/exportOrderCountAndAmountByUser',
    secondary_order_tracking_report: 'orderReport/secondaryOrderTracking',
    export_secondary_order_tracking_report: 'orderReport/exportSecondaryOrderTracking',
    export_market_daily_sales_summary: 'orderReport/exportMarketDailySalesSummary',
    export_product_market_daily_sales_summary: 'orderReport/exportProductMarketDailySalesSummary',
    export_product_market_sales_summary: 'orderReport/exportProductMarketSalesSummary',
    retailer_product_wise_secondary_order: 'secondaryOrder/retailerProductWiseSecondaryOrder',
    export_retailer_product_wise_secondary_order: 'secondaryOrder/exportRetailerProductWiseSecondaryOrder',
    distributor_product_group_wise_secondary_order_report: 'secondaryOrder/distributorProductGroupWiseSecondaryOrder',
    export_distributor_product_group_wise_secondary_order_report: 'secondaryOrder/exportDistributorProductGroupWiseSecondaryOrder',
    user_product_group_wise_secondary_order: 'secondaryOrder/userProductGroupWiseSecondaryOrder',
    export_user_product_group_wise_secondary_order: 'secondaryOrder/exportUserProductGroupWiseSecondaryOrder',
    retailer_product_group_wise_secondary_order: 'secondaryOrder/retailerProductGroupWiseSecondaryOrder',
    export_retailer_product_group_wise_secondary_order: 'secondaryOrder/exportRetailerProductGroupWiseSecondaryOrder',



    // project report
    project_demand_sales_report: 'projectDemand/productDemandVsSale',
    project_wise_sales_forecast: 'projectSalesForecast/projectWiseSalesForecast',
    project_wise_sales_forecast_report: 'projectSalesForecast/exportProjectWiseSalesForecast',
    product_wise_sales_forecast_report: 'projectSalesForecast/exportProductWiseSalesForecast',
    product_wise_sales_forecast: 'projectSalesForecast/productWiseSalesForecast',
    product_line_wise_sales_forecast: 'projectSalesForecast/productLineWiseSalesForecast',


    // retailer report
    customer_sales_summary_performance_by_order: 'customer/retailerSalesPerformanceSummaryByOrder',
    customer_sales_summary_by_order_export: 'customer/exportRetailerSalesPerformanceSummaryByOrder',
    customer_order_vs_delivery: 'api/secondary-sales-report/order-vs-delivery',
    export_customer_order_vs_delivery: 'api/secondary-sales-report/order-vs-delivery/export',
    customer_credit_report: 'customer/creditReport',
    export_customer_credit_report: 'customer/exportCreditReport',
    total_customer_credit: 'customer/creditReport/total',
    customer_sales_performance_by_order: 'customer/retailerSalesPerformanceByOrder',
    non_productive_retailer_report: 'api/retailer/list/non-productive-retailer',
    export_non_productive_retailer_report: 'api/retailer/list/non-productive-retailer/export',
    non_productive_retailer_report_total: 'api/retailer/list/non-productive-retailer/total',
    weekly_buyer_outlet: 'api/retailer/weekly-buyer-outlet',
    export_weekly_buyer_outlet: 'api/retailer/weekly-buyer-outlet/export',
    weekly_buyer_outlet_total: 'api/retailer/weekly-buyer-outlet/total',
    weekly_buyer_outlet_list: 'api/retailer/retailer-list-of-weekly-buyer-outlet',

    // retailer invoice report
    customerInvoiceProductQuantityAndAmount: 'customerInvoice/getCustomerInvoicedProductQuantityAndAmount',
    exprtCustomerInvoiceProductQuantityAndAmount: 'customerInvoice/exportCustomerInvoicedProductQuantityAndAmount',
    retailer_to_dealer_invoice_product_quantity_and_amount: 'retailerToDealerInvoice/invoicedProductQuantityAndAmount',
    export_retailer_to_dealer_invoice_product_quantity_and_amount: 'retailerToDealerInvoice/exportInvoicedProductQuantityAndAmount',
    customer_payment_collection: 'customerInvoice/paymentCollectionReport',
    customer_payment_collection_export: 'customerInvoice/exportPaymentCollectionReport',
    customer_sales_summary_by_invoice: 'customer/retailerSalesPerformanceByInvoice',
    customer_sales_summary_performance_by_invoice: 'customer/retailerSalesPerformanceSummaryByInvoice',
    customer_sales_summary_by_invoice_export: 'customer/exportRetailerSalesPerformanceSummaryByInvoice',



    // route plan report
    tour_plan_vs_retailer_sales: 'tourPlan/tourPlanVsSales',
    export_tour_plan_vs_retailer_sales: 'tourPlan/exportTourPlanVsSales',
    plan_vs_visit_report: 'tourPlan/planVsVisit',
    route_plan_achievement: 'api/route-plan/report/route-plan-achievement',
    route_plan_achievement_export: 'api/route-plan/report/route-plan-achievement/export',



    // summary
    productMarketDailySalesSummary: 'orderReport/productMarketDailySalesSummary',
    productMarketSalesSummary: 'orderReport/productMarketSalesSummary',
    marketDailySalesSummary: 'orderReport/marketDailySalesSummary',
    marketSalesSummary: 'orderReport/marketSalesSummary',
    market_primary_sales_summary: 'monthlySalesSummaryOfMarket/primaryOrderSummary',
    market_primary_product_group_sales_summary: 'monthlySalesSummaryOfMarketAndProductGroup/primaryOrderSummary',
    market_primary_daily_product_sales_summary: 'dailySalesSummaryOfMarketAndProduct/primaryOrderSummary',
    market_secondary_daily_product_sales_summary: 'dailySalesSummaryOfMarketAndProduct/secondaryOrderSummary',
    market_secondary_product_group_sales_summary: 'monthlySalesSummaryOfMarketAndProductGroup/secondaryOrderSummary',
    market_secondary_sales_summary: 'monthlySalesSummaryOfMarket/secondaryOrderSummary',
    daily_market_sales_summary: 'summary/daily/sales/market/list',
    export_daily_market_sales_summary: 'summary/daily/sales/market/export',
    personDailySalesSummary: 'orderReport/personDailySalesSummary',
    personSalesSummary: 'orderReport/personSalesSummary',
    export_person_daily_sales_summary: 'orderReport/exportPersonDailySalesSummary',
    export_person_sales_summary: 'orderReport/exportPersonSalesSummary',
    export_market_sales_summary: 'orderReport/exportMarketSalesSummary',



    // visit summary
    project_engagement_approve: 'projectEngagement/approve',
    customer_engagement_approve: 'customerEngagement/approve',
    distributor_engagement_approve: 'distributorEngagement/approve',
    distributor_engagement_list: 'distributorEngagement/list',
    distributor_engagement_details: 'distributorEngagement',
    distributor_engagement_export: 'distributorEngagement/export',
    project_engagement_list: 'projectEngagement/list',
    customer_engagement_details: 'customerEngagement',
    project_engagement_details: 'projectEngagement',
    customer_engagement_list: 'customerEngagement/list',
    customer_engagement_export: 'customerEngagement/export',
    customer_engagement_export_new: 'api/retailer-engagement/list/export',
    daily_engagement_report: 'engagement/dailyEngagementReport',
    user_movement_report: 'engagement/movementByEngagement',
    user_movement_report_export: 'engagement/exportMovementByEngagement',
    engagement_by_user_report: 'engagement/engagementsByUser',
    target_visit_count_by_user_report: 'engagement/targetAndVisitCountByUser',
    daily_engagement_export: 'engagement/export',


    // notification rule
    notification_rule_list: 'notificationRule/list',
    edit_notification_rule: 'notificationRule/edit',
    delete_notification_rule: 'notificationRule',
    create_notification_rule: 'notificationRule/add',

    // others
    utility_upload: 'file/upload',

    // approval rules
    approval_rule_list: 'api/approval-rule/list',
    approval_rule_add: 'api/approval-rule/add',
    approval_rule_edit: 'api/approval-rule/edit',
    approval_rule_remove: 'api/approval-rule/remove',

    // da rule
    da_rule_list: 'api/da-rule/list',
    da_rule_manage: 'api/da-rule/manage',
    da_rule_remove: 'api/da-rule/remove',

    // retailer sales
    retailer_wise_details_sales_report: 'api/secondary-sales-report/retailer-sales-details',
    market_and_user_column: 'api/market/market-and-user-columns',
    export_retailer_wise_details_sales_report: 'api/secondary-sales-report/retailer-sales-details/export',
    retailer_due_report_by_date_market_retailer_distributor: 'api/secondary-sales-report/retailer-due-report-by-date-market-retailer-distributor',
    export_retailer_due_report_by_date_market_retailer_distributor: 'api/secondary-sales-report/retailer-due-report-by-date-market-retailer-distributor/export',
    retailer_order_summary_by_category: 'api/secondary-sales-report/retailer-order-summary-by-category-and-volume',
    export_retailer_order_summary_by_category: 'api/secondary-sales-report/retailer-order-summary-by-category-and-volume/export',
    order_vs_delivery_by_market_and_sku: 'api/secondary-sales-report/web/order-vs-delivery-by-market-and-sku',
    order_vs_delivery_by_market_and_brand: 'api/secondary-sales-report/web/order-vs-delivery-by-market-and-brand',
    export_order_vs_delivery_by_market_and_sku: 'api/secondary-sales-report/web/order-vs-delivery-by-market-and-sku/export',
    export_order_vs_delivery_by_market_and_brand: 'api/secondary-sales-report/web/order-vs-delivery-by-market-and-brand/export',
    market_return_report: 'api/secondary-sales-report/web/market-order-return-report',
    export_market_return_report: 'api/secondary-sales-report/web/market-order-return-report/export',
    trade_spend_report: 'api/secondary-sales-report/trade-spend-report',
    export_trade_spend_report: 'api/secondary-sales-report/trade-spend-report/export',
    numeric_distribution_report: 'api/secondary-sales-report/numeric-distribution-report',
    export_numeric_distribution_report: 'api/secondary-sales-report/numeric-distribution-report/export',
    chiller_outlet_sales_report: 'api/secondary-sales-report/chiller-outlet-sales-report',
    chiller_outlet_sales_report_export: 'api/secondary-sales-report/chiller-outlet-sales-report/export',

    // invoice kpi
    plan_visit_order_invoice_user_kpi_list: 'api/plan-visit-order-invoice-kpi/get-user-kpi',
    plan_visit_order_invoice_user_kpi_export: 'api/plan-visit-order-invoice-kpi/get-user-kpi/export',
    strike_rate_for_dashboard: 'api/plan-visit-order-invoice-kpi/get-user-kpi/strike-rate/for-dashboard',
    strike_rate_for_dashboard_export: 'api/plan-visit-order-invoice-kpi/get-user-kpi/strike-rate/export',

    // IMS
    ims_list: 'api/daily-summary-ims/list',
    ims_details: 'api/daily-summary-ims/details',
    sr_list: 'api/team/filter/sr-list',
    ims_approve: 'api/daily-summary-ims/approve',
    ims_edit: 'api/daily-summary-ims/edit',
    ims_details_report: 'api/daily-summary-ims/ims-details-report',
    ims_details_report_export: 'api/daily-summary-ims/ims-details-report/export',
    ims_daily_summary_by_volume_list: 'api/daily-summary-ims/summaryByVolume/web',
    ims_daily_summary_by_volume_export: 'api/daily-summary-ims/summaryByVolume/web/export',
    ims_summary_by_category: 'api/daily-summary-ims/summary-by-category/web',
    export_ims_summary_by_category: 'api/daily-summary-ims/summary-by-category/web/export',
    monthly_ims_by_sr: 'api/daily-summary-ims/web/product-wise-ims-report-by-month-and-sr',
    export_monthly_ims_by_sr: 'api/daily-summary-ims/web/product-wise-ims-report-by-month-and-sr/export',
    update_ims_to_adjust_stock: 'api/daily-summary-ims/update-ims-to-adjust-stock',


    retailer_order_volume_summary_with_rdt_web: 'api/retailer-order/orderVolumeSummaryWithRdt/web',
    retailer_order_volume_summary_with_rdt_web_export: 'api/retailer-order/orderVolumeSummaryWithRdt/web/export',



};
